export function getQueryValue(
  query: string | string[] | undefined
): string | undefined {
  if (query === undefined) {
    return query;
  }
  if (Array.isArray(query)) {
    return query.length > 0 ? query[0] : undefined;
  }
  return query;
}
